import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { getProjectViewResources } from '@jira/router-resources__business-common/src/getBusinessProjectResources.tsx';
import { summaryBusinessEntrypoint } from '@jira/spa-apps__summary/src/summaryBusinessEntrypoint.entrypoint.tsx';
import { AsyncHorizontalNavJira } from '@jira/navigation-apps__horizontal-nav-jira/src/async.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { businessProjectLayout } from '@jira/platform__layouts-business-project-layout/src/index.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { ThemedLazySkeleton } from '@jira/platform__project-theme-components/src/ui/ThemedLazySkeleton.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { jiraBusinessSummaryRoute } from '@jira/router-routes__business-summary-routes/src/jiraBusinessSummaryRoute.tsx';
import { jiraHorizontalNavEntrypoint } from '@jira/navigation-apps__horizontal-nav-jira/src/jiraHorizontalNavEntrypoint.entrypoint.tsx';
import type { Route } from '@atlassian/react-resource-router';

const summaryBusinessPageEntrypoint = createPageEntryPoint({
	main: summaryBusinessEntrypoint,
	horizontalNavigation: jiraHorizontalNavEntrypoint,
});

export const jiraBusinessSummaryRouteEntry: Route = createEntry(jiraBusinessSummaryRoute, () => ({
	group: 'classic-business',
	ufoName: 'jwm.summary-view',
	layout: businessProjectLayout,
	skeleton: ThemedLazySkeleton,
	navigation: {
		menuId: MenuIdProjects,
		horizontal: AsyncHorizontalNavJira,
	},
	resources: [...getProjectViewResources()],
	entryPoint: () => {
		return summaryBusinessPageEntrypoint;
	},
	supportsPreviewPanel: true,
	supportsProjectTheme: 'full',
	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
